import React, {PropTypes} from "react";
import Panel from "react-bootstrap/lib/Panel";


class ProfessionalDetails extends React.Component {
  constructor() {
    super();
    this.state = {open: false}
  }

  componentDidUpdate() {
    // window.dispatchEvent(new Event('resize'));
  }

  render() {

    let data = this.props.data;
    return (
      <div>

        <button className="btn btn-block" onClick={()=> {

          this.setState({open: !this.state.open})
        }}>CANDIDATE DETAILS
        </button>
        <Panel collapsible expanded={this.state.open}>
          <table style={{width: '100%'}} className="table table-bordered">
            <thead>
            <tr>
              <th colSpan="2">CANDIDATE DETAILS</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>Name:</td>
              <td>{data.name}</td>
            </tr>
            <tr>
              <td>Personal Email Id:</td>
              <td>{data.personalEmailId}</td>
            </tr>
            <tr>
              <td>Contact No:</td>
              <td>{data.contactNo}</td>
            </tr>
            <tr>
              <td>Gender:</td>
              <td>{data.gender}</td>
            </tr>
            <tr>
              <td>Date of birth:</td>
              <td>{data.empDob}</td>
            </tr>
            <tr>
              <td>Location</td>
              <td>{data.location}</td>
            </tr>
            <tr>
              <td>Office Location</td>
              <td>{data.officeLocation}</td>
            </tr>
            <tr>
              <td>Highest Education</td>
              <td>{data.highestEducation}</td>
            </tr>
            <tr>
              <td>Skills</td>
              <td>{data.skills}</td>
            </tr>

            </tbody>

          </table>
        </Panel>
      </div>
    );
  }

}

ProfessionalDetails.proptypes = {};

export default ProfessionalDetails;



/** WEBPACK FOOTER **
 ** ./src/feature/onboarding/components/CandidateDetails.js
 **/